<template>
  <div class="menu-subcategories-list">
    <!-- Sottocategorie del Menu-->
    <div
      class="text-sans-caption is-text-uppercase m-bottom-32px hide-for-small"
    >
      {{ $t('menu.categories.proposte') }}
    </div>
    <ul>
      <li v-for="subcategory in subcategories" :key="subcategory.id">
        <NuxtLink
          data-no-cursor
          :to="
            localePath({
              name: 'piatti-e-vini-category-slug',
              params: {
                category: category,
                slug: useMenuUtils().extractNodeSlug(subcategory),
              },
            })
          "
          class="text-sans-l"
          :class="{
            'link-underline-1 --active':
              useMenuUtils().extractNodeSlug(activeSubcategory) ===
              useMenuUtils().extractNodeSlug(subcategory),
            'link-underline-reverse-1':
              useMenuUtils().extractNodeSlug(activeSubcategory) !==
              useMenuUtils().extractNodeSlug(subcategory),
          }"
        >
          <span>{{
            useMenuUtils().extractNodeName(subcategory, 'wine-category')
          }}</span>
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PagesMenuSubcategoriesList',
}
</script>

<script setup>
const { locale } = useI18n()
const touch = ref(false)

const props = defineProps({
  category: {
    type: String,
    default: '',
  },
  subcategories: {
    type: Array,
    default: () => [],
  },
  activeSubcategory: {
    type: Object,
    default: () => ({}),
  },
})

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints
})
</script>

<style lang="scss">
@import './style.scss';
</style>
